export default "__VITE_ASSET__CepH0Br8__"